<template>
    <div  v-if="markerType == 'label'" :class="['marker-overlay', {visible:isVisible}]" :id="category.id"  ref="outer" >
        <a class="show-on-focus" href="#" @click.prevent="skipToNext">Category is {{category.name}}. Skip to next Category</a>
        <label-marker v-for="marker in markers" :key="marker.id" :marker="marker"/>
    </div>

    <div  v-else-if="markerType == 'detailed'" :class="['marker-overlay', {visible:isVisible}]" :id="category.id"  >
        <a class="show-on-focus" href="#" @click.prevent="skipToNext">Category is {{category.name}}. Skip to next Category</a>
        <popup-marker
                :key="'m'+marker.id"
                v-for="marker in markers"
                :marker="marker"
                :portal="portal"
                :hooks="hooks"
                ref='marker'
        />
    </div>

</template>

<script>

    import PopUpMarker from './PopUpMarkerVuex.vue';
    import LabelMarker from './LabelMarker.vue';
import { hooks } from '../mixins/hooks.js';
    export default {
        name: 'MarkerOverlay',
        components : {
            'label-marker': LabelMarker,
            'popup-marker' : PopUpMarker
        },
        data () {
            return {
                // isVisible:this.category.visible,
            }
        },
        mixins: [hooks],
        methods : {
            show(){ this.isVisible = true},
            hide(){ this.isVisible = false },
/*            skipToNext(){
//needs reinstating
                EventBus.$emit('nextCat', this.index);

            },*/
            toggle(){
                // this.isVisible = !this.isVisible
            },
            
        },
        mounted(){
            //console.log('markers:',this.markers);
            this.$nextTick( ()=>{this.doHook('overlayMount')}  );
        },
        created (){
        },
        computed:{
            markerType(){ return this.$store.getters.genOpt({key:'markerType'});},
            markers(){
                const allMarkers = this.$store.getters.genOpt({key:'markers'});
                return allMarkers.filter((m)=>{
                    return m.category === this.category.id
                });
            },
            isVisible (){
                const visibleCats = this.$store.getters.rtVisCats;
                return visibleCats ? visibleCats.includes(this.category.id) : false
            }
        },
        props :['category', 'portal', 'hooks'],

    }
</script>

<style scoped lang="scss">
    .marker-overlay{display: block;opacity: 0; /*pointer-events: none; */position: absolute; top:0; left: 0; width: 100%; height: 100%;}
    .marker-overlay.visible{opacity: 1; }
</style>



// WEBPACK FOOTER //
// src/components/MarkerOverlayVuex.vue